import React, {useState} from 'react'
import {useHistory, useLocation} from "react-router-dom";
import {useForm} from "react-hook-form";
import axios from "axios";
import {checkMasterKeyTermKeysByTermApi, validateAndSaveTerminalKeysApi} from "../Api";
import {toast} from "react-toastify";
import ConsoleHelper from "../ConsoleHelper";

const MasterKeyTerminalInfoStepTwo = ({prevStep, nextStep, handleChange,handleValueChangeEvent, values }) => {
    const history = useHistory();
    const location = useLocation();
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [showInfoPartOne, setShowInfoPartOne] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [postMessage, setpostMessage] = useState();
    const [generateButtonToDisable, setGenerateButtonToDisable] = useState(false);
    const {  terminalID,serviceID, sequenceNumber, isServiceIDInserted,lastName,country,levelOfEducation} = values
   //

    const Continue = e => {
        e.preventDefault();
        nextStep();
    }

    const Previous = e => {
        e.preventDefault();
        prevStep();
    }


    const onSubmit = (data, e) => {
        handleValueChangeEvent('serviceID:'+data.serviceID)
        handleValueChangeEvent('sequenceNumber:'+data.sequenceNumber)
        console.log("--VALIDATING INPUT FOR STEP 2-----",data)

        /*let result = axios.get(`${validateAndSaveTerminalKeysApi}?data=${encodeURI(JSON.stringify(data))}&paramTerminalID=${terminalID}&paramUserID1=${loggedUserStorage}`,{
            mode: 'no-cors' // 'cors' by default
        });*/
        let result = axios.get(`${validateAndSaveTerminalKeysApi}?data=${encodeURI(JSON.stringify(data))}&paramTerminalID=${terminalID}&paramUserID1=${loggedUserStorage}`,{
            mode: 'no-cors' // 'cors' by default
        })
            .then(res => {
                if(res.data.message.includes("successfully")){
                    setGenerateButtonToDisable(true);
                }else{
                    setGenerateButtonToDisable(false);
                }
                setpostMessage(res.data.message)
                ConsoleHelper(res.data.message)
                //toast.warn(res.data.message, {position: toast.POSITION.TOP_CENTER,autoClose:1000})
            }).catch(error => {
                setGenerateButtonToDisable(false);
                setErrorMessage("Key binding Failed")
            //toast.error("Key binding Failed", {position: toast.POSITION.TOP_CENTER,autoClose:1000})
        });
       // console.log("---- Propogated values",values)
    };



    const styles = {
        container: {
            width: "80%",
            margin: "0 auto",
        },
        input: {
            width: "100%",
        },
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <h5 className="tbsub-title mt-3 mb-3" style={{textAlign: "center"}}>Step 2 of 3</h5>
                    <div className="form-group row col-md-6" style={{margin: "0 auto"}}>
                        <p style={{color: "green"}}>
                            <strong> {postMessage ?""+ postMessage : errorMessage}</strong>
                        </p>
                    </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="col-md-12">
                        {isServiceIDInserted ? (
                        <div className="form-group row">
                            <label className="control-label col-md-4">The info 1 has just inserted.</label>
                        </div>
                            ):(
                        <div className="form-group row">
                            <h4 className="tbsub-title mt-3 mb-3"> Please, enter info for part 1</h4>
                            <div className="form-group row col-md-12">
                                <label className="control-label col-md-4" style={{textAlign: "center"}}> Terminal
                                    ID:</label>
                                <label>{terminalID}</label>
                            </div>
                            <div className="form-group row col-md-12">
                                <label className="control-label col-md-4" style={{textAlign: "center"}}> Service
                                    ID: </label>
                                <input type="text" {...register("serviceID", { required: true, maxLength: 200 })}
                                       style={{
                                           ...styles.input,
                                           borderColor: errors.serviceID && "red",
                                           marginRight: "50px"
                                       }}
                                       className="form-control form-control-sm col-md-3"/>
                            </div>
                            <div className="form-group row col-md-12">
                                <label className="control-label col-md-4" style={{textAlign: "center"}}> Sequence
                                    Number:</label>
                                <input type="text" {...register("sequenceNumber", { required: true, maxLength: 200 })}
                                       style={{
                                           ...styles.input,
                                           borderColor: errors.sequenceNumber && "red",
                                           marginRight: "50px"
                                       }}
                                       className="form-control form-control-sm col-md-3"/>
                            </div>
                            <div className="form-group row col-md-12" style={{margin: "0 auto"}}>
                                {generateButtonToDisable ? (
                                    <button disabled={true} className="btn btn-primary col-md-3"
                                            type="submit" style={{padding: "3px"}}
                                            value="Generate"
                                    >Generate
                                    </button>
                                ) : (
                                    <button className="btn btn-primary col-md-3"
                                            type="submit" style={{padding: "3px"}}
                                            value="Generate"
                                    >Generate
                                    </button>
                                )}
                            </div>
                        </div>
                        )}
                    </div>
                    <button onClick={Continue}
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="btn btn-primary"
                            style={{float: "right"}}
                    >Next</button>

                    <button onClick={ Previous }
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="btn btn-primary"
                            style={{float: "right",marginRight: "100px"}}
                    >Prev</button>

                </form>
            </div>
        </div>
    )
}

export default MasterKeyTerminalInfoStepTwo